import './styles.scss'
import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import PaymentMethodEdit from '../Management/Companies/PaymentMethodEdit'
import { Button } from 'components/Form'
import PlanPriceSelector from 'components/Form/PlanPriceSelector'

const ConfirmationModal = (props) => {

  const getModalMode = () => {
    if (props.modalMode === 'change_plan') {
      return (
        <PlanPriceSelector
          onChange={(error, isOk) => props.primaryAction(isOk)}
        />
      )
    } else {
      return (
        <PaymentMethodEdit />
      )
    }
  }

  return (
    <div className='plan-modal'>
      <div className='close-container'>
        <i className='fa fa-times' onClick={props.cancelAction}></i>
      </div>
      { props.modalMode === '' ?
        <>
          <div className='modal-body'>
            { props.titleKey !== '' ?
              <div className='modal-title'
                dangerouslySetInnerHTML={{ __html: I18n.t(props.titleKey) }}
              />: null
            }
            { props.subtitles.map((subtitle, index) => (
              <div className='modal-subtitle' key={index}
                dangerouslySetInnerHTML={{ __html: I18n.t(subtitle) }}
              />
            ))}
          </div>
          <div className='modal-footer'>
            <Button secondary value={I18n.t(props.buttonTextKey)} onClick={props.primaryAction} />
            <Button value={I18n.t('dashboard_cancel')} onClick={props.cancelAction} />
          </div>
        </> : getModalMode()
      }
    </div>
  )
}

export default ConfirmationModal
